<template>
  <div class="fb">
    <div class="fb-header">
      <div class="fb-header-icon"><i class="fa fa-life-ring"></i></div>
      <div>
        <h4 class="fb-h">الدعم الفني</h4>
        <div class="fb-sub">نحن هنا لمساعدتك — اختر الطريقة المناسبة</div>
      </div>
    </div>

    <div class="fb-options">
      <button type="button" id="fb-open-bot" class="fb-opt" :class="{ on: mode == 'bot' }" @click="openMode('bot')">
        <span class="fb-opt-icon fb-i-bot"><i class="fa fa-magic"></i></span>
        <span class="fb-opt-text">
          <strong>المساعد الذكي</strong>
          <small>إجابات فورية عن أي سؤال في النظام، على مدار الساعة</small>
        </span>
      </button>
      <!-- a school the support team stopped from urgent tickets gets «تذكرة دعم فني» instead -->
      <button v-if="supportState == 'blocked'" type="button" id="fb-open-normal" class="fb-opt" :class="{ on: mode == 'normal' }" @click="openMode('normal')">
        <span class="fb-opt-icon fb-i-normal"><i class="fa fa-life-ring"></i></span>
        <span class="fb-opt-text">
          <strong>تذكرة دعم فني</strong>
          <small>اكتب مشكلتك أو استفسارك، ويرد عليك فريق الدعم داخل التذكرة</small>
        </span>
      </button>
      <button v-else type="button" id="fb-open-urgent" class="fb-opt fb-opt-urgent" :class="{ on: mode == 'urgent' }" @click="openMode('urgent')">
        <span class="fb-opt-icon fb-i-urgent"><i class="fa fa-bell"></i></span>
        <span class="fb-opt-text">
          <strong>الدعم الفني السريع <span class="fb-hot"><i class="fa fa-bolt"></i> عاجل</span><span v-if="supportState == 'not_subscribed'" class="fb-paid"><i class="fa fa-star"></i> للمشتركين</span></strong>
          <small>لمشكلة عاجلة تحتاج تدخلاً فورياً — يصل فريق الدعم فوراً</small>
        </span>
      </button>
      <a class="fb-opt" :href="whatsapp" target="_blank" rel="noopener">
        <span class="fb-opt-icon fb-i-wa"><i class="fa fa-whatsapp"></i></span>
        <span class="fb-opt-text">
          <strong>تواصل معنا عبر واتساب</strong>
          <small>الدعم الفني · <bdi dir="ltr">966580200670</bdi></small>
        </span>
      </a>
    </div>

    <div v-if="mode" ref="panel" class="card fb-panel" :class="{ 'fb-panel-urgent': mode == 'urgent', 'fb-panel-paid': mode == 'paid' && paidState != 'blocked' }">
      <button type="button" class="fb-close" aria-label="إغلاق" @click="mode = ''"><i class="fa fa-times"></i></button>
      <support-bot v-if="mode == 'bot'" @urgent="fromBot" />
      <paid-only-notice v-else-if="mode == 'paid'" :state="paidState" :message="paidReason" @bot="openMode('bot')" @normal="openMode('normal', prefill)" />
      <urgent-ticket-form v-else :key="formKey" :normal="mode == 'normal'" :prefill="prefill" @created="ticketCreated" @paid-only="paidOnly" />
    </div>

    <div class="fb-more-title">طرق أخرى للتواصل</div>
    <div class="fb-more">
      <button type="button" class="fb-more-btn" :class="{ on: type == 'ticket' }" @click="openType('ticket')">
        <i class="fa fa-wrench"></i> ابلاغ عن مشكلة في النظام
      </button>
      <button type="button" class="fb-more-btn" :class="{ on: type == 'feedback' }" @click="openType('feedback')">
        <i class="fa fa-lightbulb-o"></i> رأيك واقتراحك لتطوير النظام
      </button>
      <button type="button" class="fb-more-btn" :class="{ on: type == '3' }" @click="openType('3')">
        <i class="fa fa-phone"></i> حجز موعد اتصال عبر الجوال
      </button>
    </div>

    <div v-if="type" class="card card-body fb-panel">
      <button type="button" class="fb-close" aria-label="إغلاق" @click="type = ''"><i class="fa fa-times"></i></button>
            <template v-if="type == '3'">
                <div class="form-group">
                  <h5 for="">سبب الاتصال</h5>
                  <textarea class="form-control form-control-lg" v-model="reason" rows="3" placeholder="برجاء توضيح سبب الاتصال. مثل: استفسار عن كذا، مشكلة كذا"></textarea>
                </div>
                <div class="form-group">
                  <h5 for="">رقم الجوال المراد الاتصال به</h5>
                  <input type="text"
                    class="form-control form-control-lg" v-model="phone" placeholder="اكتب رقم الجوال المراد الاتصال عليه">
                </div>
                <strong>
                    <h5>اختر موعد الاتصال المناسب لك:</h5>
                </strong>
                <div class="form-group" v-if="reason == 'lolo'">
                  <label for="">موعد اتصال مخصص</label>
                  <input type="datetime-local"
                    class="form-control" v-model="selected_time_custom" @change="selected_time_customx()">
                </div>
                <div class="alert alert-warning g" v-if="times.length == 0">
                    لا يوجد مواعيد متاحة للاتصال، برجاء التواصل معنا عبر الواتس اب.
                </div>
                <template v-if="reason != 'lolo'">
                    <div v-for="t in times" :key="t.date" class="form-check">
                        <label class="form-check-label">
                        <input type="radio" class="form-check-input" v-model="selected_time" :value="t">
                        {{ t.title }}
                    </label>
                    </div>
                </template>
                <div class="col-12 text-center g">
                    <button class="btn btn-primary" @click="registerTime()">
                        حجز الموعد الآن
                    </button>
                </div>
            </template>
            <template v-if="type == 'ticket' || type == 'feedback'">
                <div class="form-group">
                <h5 for="">الخدمة</h5>
                <select class="form-control" v-model="service">
                    <option value="النظام">النظام بشكل عام</option>
                    <option v-for="s in services" :key="s.title" :value="s.title">
                        {{ s.title }}
                    </option>
                </select>
                </div>
                <div class="form-group">
                <h5 for="">{{ type == 'ticket' ? 'المشكلة' : 'رأيك / اقتراحك بالتفصيل' }}</h5>
                <textarea class="form-control" v-model="title" placeholder="اكتب هنا..." rows="3"></textarea>
                </div>
                <div class="form-group" v-if="type == 'feedback'">
                <h5 for="">ما هو تقييمك للنظام الحالي؟</h5>
                <select class="form-control" v-model="rate">
                    <option value="سيئ">سيئ</option>
                    <option value="يحتاج بعض التحسينات">يحتاج بعض التحسينات</option>
                    <option value="جيد">جيد</option>
                    <option value="ممتاز">ممتاز</option>
                </select>
                </div>
                <div class="form-group">
                <span for="">ارفاق ملف / صورة توضيحية (اختياري)</span>
                <input type="file"
                    class="form-control" id="ingredient_file" @change="uploadImage()" accept=".jpg,.png,.gif,.jpeg,.doc,.docx,.pdf,.xls,.xlsx">
                </div>
                <div class="alert alert-info g text-center" v-if="uploading">
                    جاري الرفع...
                </div>
                <div class="col-12 text-center g" v-if="!uploading">
                    <button class="btn btn-success" v-if="!sending" @click="send()">
                        ارسال الآن <i class="fa fa-arrow-left"></i>
                    </button>
                    <button class="btn btn-success" v-if="sending">
                        جاري الارسال...
                    </button>
                </div>
            </template>
    </div>

    <div class="card fb-tickets">
      <div class="fb-tickets-head">
        <h5 class="fb-tickets-title">تذاكري</h5>
        <span class="fb-count">{{ countLabel }}</span>
        <button type="button" class="fb-refresh" :disabled="ticketsLoading" aria-label="تحديث" @click="loadTickets">
          <i class="fa fa-refresh" :class="{ 'fa-spin': ticketsLoading }"></i>
        </button>
      </div>
      <div v-if="ticketsError" class="fb-error">{{ ticketsError }}</div>
      <div v-else-if="ticketsLoaded && !tickets.length" class="fb-empty">
        <i class="fa fa-ticket"></i>
        <div><strong>لا توجد تذاكر</strong></div>
        <div>عند أي مشكلة عاجلة افتح تذكرة «الدعم الفني السريع» وتابعها من هنا</div>
      </div>
      <router-link v-for="t in tickets" :key="t._id" :to="'/ticket/' + t._id" class="fb-t" :class="{ 'fb-t-unread': t.unread > 0 }">
        <span class="fb-t-icon" :class="iconClass(t)"><i class="fa" :class="iconOf(t)"></i></span>
        <span class="fb-t-main">
          <span class="fb-t-title">{{ t.title }}</span>
          <span class="fb-t-last">{{ t.last_from == 1 ? 'الدعم: ' : '' }}{{ t.last_text }}</span>
          <span class="fb-t-chips">
            <span class="fb-chip" :class="t.status == 1 ? 'fb-chip-closed' : 'fb-chip-open'">{{ t.status == 1 ? 'مغلقة' : 'مفتوحة' }}</span>
            <span v-if="t.urgent" class="fb-chip fb-chip-urgent"><i class="fa fa-bolt"></i> دعم سريع</span>
            <span v-else-if="t.type == 'feedback'" class="fb-chip">اقتراح</span>
            <span v-else class="fb-chip">مشكلة</span>
            <span v-if="t.unread > 0" class="fb-chip fb-chip-new">{{ t.unread == 1 ? 'رد جديد' : t.unread + ' ردود جديدة' }}</span>
          </span>
        </span>
        <span class="fb-t-time">{{ ago(t.last_at || t.date) }}</span>
      </router-link>
    </div>

    <div v-if="mytimes.length" class="card card-body">
    <div v-if="mytimes.length">
        <div class="card card-body">
            <h5>مواعيد الاتصال</h5>
            <div class="col-12 table-responsive" style="min-height: auto !important;">
                <table class="table table-hover table-striped table-striped table-sm">
                    <thead>
                        <th>
                            الحالة
                        </th>
                        <th>
                            موعد الاتصال
                        </th>
                        <th>
                            السبب
                        </th>
                        <th>
                            الرقم
                        </th>
                        <th>
                            خيارات
                        </th>
                    </thead>
                    <tbody>
                        <tr v-for="time in mytimes" :key="time._id">
                            <td>
                                <span v-if="time.status == 0" class="btn btn-sm btn-warning">
                                    في الانتظار
                                </span>
                                <span v-if="time.status == 1" class="btn btn-sm btn-success">
                                    تم الاتصال
                                </span>
                                <span v-if="time.status == 2" class="btn btn-sm btn-danger">
                                    ملغي
                                </span>
                            </td>
                            <td>
                                {{ time.date }}
                            </td>
                            <td>
                                {{ time.reason }}
                            </td>
                            <td>
                                {{ time.phone }}
                            </td>
                            <td>
                               <button class="btn btn-outline-danger btn-sm" @click="cancel(time._id)" v-if="time.status == 0">
                                    <i class="fa fa-times"></i>
                                    الغاء الموعد
                               </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    </div>
  </div>
</template>

<script>
import SupportBot from '@/views/support/SupportBot.vue';
import UrgentTicketForm from '@/views/support/UrgentTicketForm.vue';
import PaidOnlyNotice from '@/views/support/PaidOnlyNotice.vue';
import { call, ago, WHATSAPP, urgentAccess } from '@/views/support/support-api';

// «خدمة العملاء / اتصل بنا»: the new support (AI assistant, «الدعم الفني السريع», WhatsApp, my tickets)
// on top; the older problem report, suggestion and call booking flows are unchanged below it.
export default {
    components: { SupportBot, UrgentTicketForm, PaidOnlyNotice },
    data(){
        return {
            user: JSON.parse(localStorage.getItem('user')),
            service: "النظام",
            selected_time: null,
            services: [],
            rate: "جيد",
            content: "",
            sending: false,
            selected_time_custom: "",
            reason: "",
            uploading: false,
            phone: "",
            mytimes: [],
            times: [],
            file: "",
            title: "",
            type: "",
            mode: "",
            prefill: "",
            formKey: 0,
            whatsapp: WHATSAPP,
            tickets: [],
            ticketsLoaded: false,
            ticketsLoading: false,
            ticketsError: "",
            // what the support page offers: 'allowed' (urgent) | 'blocked' (normal ticket instead)
            // | 'not_subscribed' (subscribe first) | null (not known: older server / offline)
            supportState: null,
            urgentChecked: null,
            paidState: "not_subscribed",
            paidReason: "",
        }
    },
    computed: {
        countLabel(){
            var n = this.tickets.length;
            if (!n) return '';
            if (n == 1) return 'تذكرة واحدة';
            if (n == 2) return 'تذكرتان';
            return n + (n <= 10 ? ' تذاكر' : ' تذكرة');
        },
    },
    watch: {
        '$route.query'(){ this.fromQuery(); },
    },
    created(){
        var g = this;
        this.loading = true
        g.phone = g.user.phone
        $.post(api + '/general/services', {
            jwt: this.user.jwt
        }).then(function(r){
            if(r.status != 100){
                alert(r.response)
            }else{
                g.services = r.response
            }
        }).fail(function(){
            g.loading = false
        })
        g.loadTickets()
        g.cc()
        g.checkUrgent()
        g.fromQuery()
    },
    methods: {
        ago: ago,
        // /feedback?open=bot|urgent|normal&q=… (the floating «الدعم الفني» button and the assistant link here)
        fromQuery(){
            var q = this.$route.query || {};
            if (q.open == 'bot' || q.open == 'urgent' || q.open == 'normal') this.openMode(q.open, q.q ? q.q.toString() : '');
        },
        // asked once per visit (the server decides again on /urgent and /ticket/create anyway)
        checkUrgent(){
            var g = this;
            if (!g.urgentChecked) {
                g.urgentChecked = urgentAccess().then(function(a){
                    g.supportState = a.state;
                    g.paidReason = a.message || '';
                    return a;
                });
            }
            return g.urgentChecked;
        },
        // the server refused the form: 'not_subscribed' (subscribe first) or 'blocked' (→ normal ticket)
        paidOnly(message, state){
            this.supportState = state || 'not_subscribed';
            this.paidState = this.supportState;
            if (message) this.paidReason = message;
            this.mode = 'paid';
        },
        openMode(m, prefill){
            var g = this;
            if (m == 'urgent') {
                // paid → the urgent form; stopped → notice with «فتح تذكرة دعم فني»; demo → subscribe first
                return g.checkUrgent().then(function(a){
                    if (a.state == 'blocked' || a.state == 'not_subscribed') {
                        g.paidState = a.state;
                        g.prefill = prefill || '';
                        return g.showMode('paid');
                    }
                    g.showMode('urgent', prefill);
                });
            }
            g.showMode(m, prefill);
        },
        showMode(m, prefill){
            this.type = '';
            this.mode = m;
            if (m == 'urgent' || m == 'normal') {
                this.prefill = prefill || '';
                this.formKey++;
            }
            var g = this;
            g.$nextTick(function(){
                var p = g.$refs.panel;
                if (p && p.scrollIntoView) p.scrollIntoView({ behavior: 'smooth', block: 'start' });
            });
        },
        openType(t){
            this.mode = '';
            this.type = this.type == t ? '' : t;
        },
        fromBot(question){
            this.openMode('urgent', question);
        },
        ticketCreated(id){
            this.$router.push('/ticket/' + id + '?new=1');
        },
        iconOf(t){
            if (t.urgent) return 'fa-bell';
            return t.type == 'feedback' ? 'fa-lightbulb-o' : 'fa-wrench';
        },
        iconClass(t){
            if (t.urgent) return 'fb-t-icon-urgent';
            return t.type == 'feedback' ? 'fb-t-icon-idea' : '';
        },
        loadTickets(){
            var g = this;
            g.ticketsLoading = true;
            call('/tickets').then(function(r){
                g.ticketsLoading = false;
                g.ticketsLoaded = true;
                if (r.ok) {
                    g.tickets = r.data || [];
                    g.ticketsError = '';
                } else {
                    g.ticketsError = r.message;
                }
            });
        },
        uploadImage(){
            var g = this;
            var Upload = function (file) {
                this.file = file;
            };

            Upload.prototype.getType = function () {
                return this.file.type;
            };
            Upload.prototype.getSize = function () {
                return this.file.size;
            };
            Upload.prototype.getName = function () {
                return this.file.name;
            };
            Upload.prototype.doUpload = function () {
                var that = this;
                var formData = new FormData();
                g.uploading = true;
                // add assoc key values, this will be posts values
                formData.append("file", this.file, this.getName());
                formData.append("jwt", g.user.jwt);

                $.ajax({
                type: "POST",
                url: api + '/user/general/upload',
                xhr: function () {
                    var myXhr = $.ajaxSettings.xhr();
                    if (myXhr.upload) {
                    myXhr.upload.addEventListener(
                        "progress",
                        that.progressHandling,
                        false
                    );
                    }
                    return myXhr;
                },
                success: function (data) {
                    // your callback here
                    g.uploading = false;
                    if(data.status != 100){
                        alert("هذا الملف غير مدعوم", 200)
                        return;
                    }
                    g.file = data.response
                },
                error: function (error) {
                    // handle error
                    alert("حدث خطأ");
                    g.uploading = false;
                },
                async: true,
                data: formData,
                cache: false,
                contentType: false,
                processData: false,
                timeout: 60000,
                });
            };
            var file = $("#ingredient_file")[0].files[0];
            var upload = new Upload(file);
            upload.doUpload();
        },
        cancel(id){
            var g = this;
            if(confirm("متأكد من الغاء موعد الاتصال؟")){
                $.post(api + '/user/general/cancel-time', {
                    jwt: this.user.jwt,
                    id: id
                }).then(function(r){
                    if(r.status != 100){
                        alert(r.response, 200)
                    }else{
                        alert("تم الغاء الموعد بنجاح", 100)
                        g.cc()
                    }
                }).fail(function(){
                    g.loading = false
                })
            }
        },
        selected_time_customx(){
            var g = this;
            g.selected_time = {
                title: g.selected_time_custom.replace("T", " "),
                date: g.selected_time_custom.replace("T", " ")
            }
        },
        cc(){
            var g = this;
            $.post(api + '/user/general/times', {
                jwt: this.user.jwt
            }).then(function(r){
                if(r.status != 100){
                    alert(r.response)
                }else{
                    g.times = r.response
                    if(r.response[0]){
                        g.selected_time = r.response[0]
                    }
                }
            }).fail(function(){
                g.loading = false
            })
            $.post(api + '/user/general/my-registers-times', {
                jwt: this.user.jwt
            }).then(function(r){
                if(r.status != 100){
                    alert(r.response)
                }else{
                    g.mytimes = r.response
                }
            }).fail(function(){
                g.loading = false
            })
        },
        send(){
            var g = this;
            g.sending = true;
            $.post(api + '/user/general/feedback', {
                jwt: this.user.jwt,
                service: this.service,
                title: this.title,
                rate: this.rate,
                file: this.file,
                type: this.type
            }).then(function(r){
                g.sending = false;
                if(r.status != 100){
                    alert(r.response, 200)
                }else{
                    g.loadTickets();
                    alert("تم الارسال لادارة النظام بنجاح!", 100)
                    g.$router.push(`/ticket/${r.response}`)
                }
            }).fail(function(){
                g.sending = false;
                alert('حدث خطأ في الاتصال', 200)
            })
        },
        registerTime(){
            var g = this;
            if(!g.selected_time){
                return alert("قم باختيار موعد", 200);
            }
            $.post(api + '/user/general/register-time', {
                jwt: this.user.jwt,
                date: this.selected_time.date,
                title: this.selected_time.title,
                phone: this.phone,
                reason: this.reason
            }).then(function(r){
                if(r.status != 100){
                    alert(r.response, 200)
                }else{
                    alert("تم حجز الموعد بنجاح", 100)
                    g.cc()
                }
            }).fail(function(){
                g.loading = false
            })
        }
    }
}
</script>

<style scoped>
.fb { max-width: 980px; margin: 0 auto; display: flex; flex-direction: column; gap: 14px; padding-bottom: 90px; }
.fb-header { display: flex; align-items: center; gap: 14px; }
.fb-header-icon { width: 52px; height: 52px; border-radius: 16px; background: linear-gradient(135deg, #4f46e5, #2563eb); color: #fff; display: flex; align-items: center; justify-content: center; font-size: 24px; flex: 0 0 auto; }
.fb-h { margin: 0; font-weight: 700; }
.fb-sub { opacity: 0.7; }

.fb-options { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 12px; }
.fb-opt {
  display: flex; align-items: center; gap: 12px; padding: 16px; border-radius: 16px; text-align: start;
  border: 1px solid rgba(127, 127, 127, 0.18); background: var(--fb-surface, #fff); color: inherit; cursor: pointer;
  box-shadow: 0 4px 18px rgba(34, 41, 47, 0.06); text-decoration: none;
}
.fb-opt:hover { border-color: rgba(37, 99, 235, 0.45); color: inherit; text-decoration: none; }
.fb-opt.on { border-color: var(--primary); box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.18); }
.fb-opt-urgent { border-color: rgba(234, 84, 85, 0.35); background: rgba(234, 84, 85, 0.05); }
.fb-opt-urgent:hover, .fb-opt-urgent.on { border-color: #ea5455; box-shadow: 0 0 0 2px rgba(234, 84, 85, 0.18); }
.fb-opt-icon { width: 50px; height: 50px; border-radius: 15px; color: #fff; display: flex; align-items: center; justify-content: center; font-size: 22px; flex: 0 0 auto; }
.fb-i-bot { background: linear-gradient(135deg, #4f46e5, #2563eb); }
.fb-i-urgent { background: linear-gradient(135deg, #f87171, #dc2626); }
.fb-i-wa { background: linear-gradient(135deg, #34d399, #16a34a); }
.fb-opt-text { display: flex; flex-direction: column; gap: 4px; min-width: 0; }
.fb-opt-text strong { font-size: 15px; display: flex; align-items: center; gap: 6px; flex-wrap: wrap; }
.fb-opt-urgent .fb-opt-text strong { color: #c62828; }
.fb-opt-text small { opacity: 0.75; line-height: 1.7; }
.fb-hot { font-size: 11px; padding: 1px 8px; border-radius: 999px; background: rgba(234, 84, 85, 0.14); color: #c62828; }

.fb-panel { position: relative; padding: 18px; border-radius: 16px; margin: 0; }
.fb-panel-urgent { border: 1px solid rgba(234, 84, 85, 0.3); }
.fb-panel-paid { border: 1px solid rgba(245, 158, 11, 0.4); }
.fb-i-normal { background: linear-gradient(135deg, #64748b, #334155); }
.fb-paid { display: inline-flex; align-items: center; gap: 4px; margin-inline-start: 6px; padding: 1px 8px; border-radius: 999px;
  background: rgba(245, 158, 11, 0.14); color: #b45309; font-size: 11px; font-weight: 700; vertical-align: middle; }
.fb-close { position: absolute; top: 10px; width: 34px; height: 34px; border: 0; border-radius: 10px; background: transparent; color: inherit; opacity: 0.6; cursor: pointer; z-index: 2; inset-inline-end: 10px; }
.fb-close:hover { opacity: 1; background: rgba(127, 127, 127, 0.1); }

.fb-more-title { font-weight: 700; margin-top: 6px; }
.fb-more { display: flex; flex-wrap: wrap; gap: 8px; }
.fb-more-btn {
  display: inline-flex; align-items: center; gap: 8px; padding: 9px 14px; border-radius: 12px;
  border: 1px solid rgba(127, 127, 127, 0.25); background: transparent; color: inherit; cursor: pointer; font-weight: 600;
}
.fb-more-btn:hover { background: rgba(127, 127, 127, 0.07); }
.fb-more-btn.on { border-color: var(--primary); color: var(--primary); }

.fb-tickets { padding: 16px 0 6px; border-radius: 16px; margin: 0; }
.fb-tickets-head { display: flex; align-items: center; gap: 10px; padding: 0 16px 10px; }
.fb-tickets-title { margin: 0; font-weight: 700; }
.fb-count { flex: 1; color: var(--primary); font-size: 13px; }
.fb-refresh { border: 0; background: transparent; color: inherit; width: 34px; height: 34px; border-radius: 10px; cursor: pointer; opacity: 0.7; }
.fb-refresh:hover { opacity: 1; background: rgba(127, 127, 127, 0.1); }
.fb-error { margin: 0 16px 10px; padding: 10px 12px; border-radius: 10px; background: rgba(234, 84, 85, 0.1); color: #c62828; }
.fb-empty { padding: 26px 16px 30px; text-align: center; opacity: 0.75; line-height: 1.9; }
.fb-empty .fa { font-size: 28px; opacity: 0.5; margin-bottom: 6px; }
.fb-t { display: flex; align-items: flex-start; gap: 12px; padding: 14px 16px; border-top: 1px solid rgba(127, 127, 127, 0.13); color: inherit; text-decoration: none; }
.fb-t:hover { background: rgba(127, 127, 127, 0.05); color: inherit; text-decoration: none; }
.fb-t-unread { background: rgba(37, 99, 235, 0.04); }
.fb-t-icon { width: 42px; height: 42px; border-radius: 12px; flex: 0 0 auto; display: flex; align-items: center; justify-content: center; background: rgba(37, 99, 235, 0.1); color: var(--primary); font-size: 18px; }
.fb-t-icon-urgent { background: rgba(234, 84, 85, 0.12); color: #ea5455; }
.fb-t-icon-idea { background: rgba(255, 159, 67, 0.15); color: #e67e22; }
.fb-t-main { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 4px; }
.fb-t-title { font-weight: 700; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.fb-t-last { font-size: 13px; opacity: 0.75; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.fb-t-chips { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 2px; }
.fb-chip { font-size: 12px; padding: 2px 10px; border-radius: 999px; background: rgba(127, 127, 127, 0.12); font-weight: 600; }
.fb-chip-open { background: rgba(40, 199, 111, 0.14); color: #1f9d55; }
.fb-chip-closed { background: rgba(127, 127, 127, 0.16); }
.fb-chip-urgent { background: rgba(234, 84, 85, 0.12); color: #c62828; }
.fb-chip-new { background: var(--primary); color: #fff; }
.fb-t-time { font-size: 12px; opacity: 0.65; white-space: nowrap; flex: 0 0 auto; }

@media (max-width: 991px) {
  .fb-options { grid-template-columns: minmax(0, 1fr); }
}
</style>
<style>
.dark-layout .fb { --fb-surface: #283046; }
</style>
